import { state, actions, getters, mutations } from '../base/index'

const countries = {
  namespaced: true,
  state: Object.assign({}, state),
  mutations: Object.assign({}, mutations),
  actions: Object.assign({}, actions),
  getters: Object.assign({}, getters)
}

countries.state.type = 'countries'
countries.state.type2 = 'country'
countries.state.url = 'countries/'

export default countries
